import { useState, useCallback } from 'react';

export const useEndedEventDetailsVisibility = (eventEnded: boolean) => {
  const [hasExpanded, setHasExpanded] = useState(false);
  const showEndedEventDetails = !eventEnded || hasExpanded;
  const expandDetails = useCallback(() => setHasExpanded(true), []);

  return { showEndedEventDetails, expandDetails };
};
